<script lang="ts">
	import Icon from '@components/Icon.svelte';
	import CollapseDown from '@icons/CollapseDown.svelte';

	export let question: string = '';
	export let id: string;

	let isOpen = false;

	function handleClick() {
		isOpen = !isOpen;
		if (isOpen) {
			setTimeout(() => {
				const content = document.getElementById(`accordion-details-${id}`);
				if (content) {
					content.focus();
				}
			}, 0);
		}
	}
</script>

<div class="text-copy border-b border-gray-10">
	<button
		class="w-full text-left font-bold py-3 pl-3 pr-9 relative hover:bg-gray-10 focus:bg-gray-10"
		class:bg-gray-11={isOpen}
		aria-expanded={isOpen}
		id="accordion-summary-{id}"
		aria-controls="accordion-details-{id}"
		on:click={handleClick}
	>
		{question}
		<Icon
			component={CollapseDown}
			class="absolute right-3 top-3.75 transition-transform {isOpen ? 'rotate-180' : ''}"
		/>
	</button>
	<div
		id="accordion-details-{id}"
		aria-labelledby="accordion-summary-{id}"
		class="p-3 transition-all"
		class:hidden={!isOpen}
		aria-hidden={!isOpen}
		role="region"
		tabindex="-1"
	>
		<slot />
	</div>
</div>
